import React from 'react';
import { ActionButtonMenuItem } from '../model';
import { MenuItem as MenuListItem, MenuItemProps as MenuListItemProps } from '../../menuList';

export interface MenuItemProps extends MenuListItemProps {
  onClick?: ActionButtonMenuItem['onClick'];
}

export const MenuItem: React.FC<MenuItemProps> = ({ onClick, disabled, ...props }) => {
  return (
    <MenuListItem
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      role={onClick ? 'button' : 'menuitem'}
      tabIndex={onClick ? 0 : undefined}
      {...props}
    />
  );
};
